// collection sorting

var customSorting = function(){

var facetsDisplays = document.querySelectorAll(".custom_facets");
var facetLists = document.querySelectorAll(".new_facets");

if(facetsDisplays){
  facetsDisplays.forEach(facetsDisplay => {
    facetsDisplay.addEventListener("click", () => {
      var facetSvg = facetsDisplay.querySelector(".icon-caret");
      facetSvg.classList.toggle("open");
      var allFacets = facetsDisplay.closest(".select").querySelector(".new_facets");
      allFacets.classList.toggle("active");
    });

    if(facetLists){
  facetLists.forEach(facetList => {
   var singleLists = facetList.querySelectorAll("li");
    singleLists.forEach((list) => {
    
      var page_url = window.location.href;
      var selected_li = list.getAttribute('selected');
      if(selected_li && selected_li != 'undefined' && list.textContent.replace(/\s/g, '') != 'Default' && page_url.includes('en')){
        // console.log(selected_li, list.textContent.replace(/\s/g, ''), page_url, 'if working');
        facetsDisplay.querySelector('.facets_label').textContent = list.textContent;
      }
      if(selected_li && selected_li != 'undefined' && list.textContent.replace(/\s/g, '') != 'Bawaan' && page_url.includes('en') == false){
        // console.log(page_url.includes('en'), selected_li, list.textContent.replace(/\s/g, ''), page_url, 'else working');
        facetsDisplay.querySelector('.facets_label').textContent = list.textContent;
      }
    
      list.addEventListener("click", () => {
        var listVal = list.innerHTML;
        console.log(listVal);
        var listValue = list.getAttribute("value");
        var paraVal = list.closest(".select").querySelector(".facets_label");
        list.closest(".new_facets").classList.remove("active");
        var repeteadValue = false;
        paraVal.innerHTML = listVal;
    
        singleLists.forEach((newList) => {
          var newListValue = newList.getAttribute("value");
          if (window.location.href.includes(newListValue)) {
            var urlParam = new URLSearchParams(window.location.search);
            urlParam.set("sort_by", listValue);
            if (window.location.href.includes("sort_by") && window.location.href.includes('search')) {
              var newLoc = window.location.pathname + "?" + urlParam.toString();
              console.log(newLoc);
            } else if (window.location.href.includes("?sort_by")){
              var newLoc = window.location.pathname + "?" + urlParam.toString();
              console.log(newLoc,'1');
            } else {
              if(window.location.href.includes('?')){
                var newLoc = window.location.pathname + "?" + urlParam.toString();
              }else{
                var newLoc = window.location.pathname + "&" + urlParam.toString();
              }
              
              console.log(window.location.pathname,newLoc,'2',urlParam.toString())
            }
            window.location.href = newLoc;
            repeteadValue = true;
          }
        });
        if (repeteadValue === false) {
          var windowLocation = window.location.href;
          var sortUrl = windowLocation.includes("?") ? "&sort_by=" : "?sort_by=";
          window.location.href = windowLocation + sortUrl + listValue;
        }
      });
    }); 
  })
}  
    
  })
}
  
// if (facetsDisplay) {
//   facetsDisplay.addEventListener("click", () => {
//     var facetSvg = facetsDisplay.querySelector(".icon-caret");
//     facetSvg.classList.toggle("open");
//     var allFacets = facetsDisplay.closest(".select").querySelector(".new_facets");
//     allFacets.classList.toggle("active");
//   });
// }


  

}


customSorting();